import React from "react";
import {withRouter} from "react-router";
import "../../scss/style.css"
import ToastHelper from "../../utils/ToastHelper";
import AgentService from "../../services/Agent/AgentService";
import LoadingSpinnerComponent from "../../components/LoadingSpinnerComponent";
import AgentPersonalDetailsComponent from "./AgentPersonalDetailsComponent";
import AgentIdentityDetailsComponent from "./AgentIdentityDetailsComponent";
import AgentAddressDetailsComponent from "./AgentAddressDetailsComponent";
import AgentContactDetailsComponent from "./AgentContactDetailsComponent";
import UserSessionService from "../../services/UserSessionService";
import AgentPrivilege from "../../enum/AgentPrivilege";

class ProfileIndex extends React.Component {

    constructor(props) {
        super(props);
        this.canEditProfile = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_EDIT_PROFILE);
        this.userId = UserSessionService.getUser().user.id;
        this.props.changeHeader("Profile");
        this.state = {
            agentData: undefined,
            loading: true
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        AgentService.retrieveByUserId(this.userId).then(response => {
            if (response.id) {
                this.setState({
                    loading: false,
                    agentData: response,
                });
            } else {
                this.setState({
                    loading: false
                });
                ToastHelper.formatError(response);
            }
        });
    }

    render() {

        if (this.state.loading) {
            return <LoadingSpinnerComponent/>
        }

        return this.state.agentData ? <div>
            <div className={"shadowContainer"}>
                <AgentPersonalDetailsComponent person={this.state.agentData.person}
                                               agentId={this.state.agentData.id}
                                               onRefresh={this.loadData.bind(this)} canEdit={this.canEditProfile}/>
                <AgentIdentityDetailsComponent identity={this.state.agentData.identity}
                                               documents={this.state.agentData.documents}
                                               agentId={this.state.agentData.id}
                                               onRefresh={this.loadData.bind(this)}
                                               canEdit={this.canEditProfile}/>
                <AgentAddressDetailsComponent address={this.state.agentData.address}
                                              agentId={this.state.agentData.id}
                                              onRefresh={this.loadData.bind(this)} canEdit={this.canEditProfile}/>
                <AgentContactDetailsComponent contacts={this.state.agentData.contacts}
                                              agentId={this.state.agentData.id}
                                              onRefresh={this.loadData.bind(this)} canEdit={this.canEditProfile}/>
            </div>
            <br/>
        </div> : <div>No Profile Data</div>
    }
}

export default withRouter(ProfileIndex);
